import { render, staticRenderFns } from "./PostDeleteModal.vue?vue&type=template&id=3430b18c&scoped=true&"
import script from "./PostDeleteModal.vue?vue&type=script&lang=js&"
export * from "./PostDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3430b18c",
  null
  
)

export default component.exports